export default __webpack_public_path__ + "static/media/rectangle-perpul.928d3a25.svg";